import {CSSProperties, HTMLAttributes} from 'react';

export type MaterialSymbolProps = HTMLAttributes<HTMLSpanElement> & {
  filled?: boolean;
  weight?: 100 | 200 | 300 | 400 | 500 | 600 | 700;
  grade?: number;
  opticalSize?: 20 | 24 | 40 | 48;
};

export const MaterialSymbol = ({
  children,
  filled = false,
  weight = 400,
  grade = 0,
  opticalSize = 24,
  style,
  className = '',
  ...props
}: MaterialSymbolProps) => {
  const fontVariationSettings = `'FILL' ${
    filled ? 1 : 0
  }, 'wght' ${weight}, 'GRAD' ${grade}, 'opsz' ${opticalSize}`;

  const combinedStyle: CSSProperties = {
    fontVariationSettings,
    ...style,
  };

  return (
    <span
      className={`material-symbols-outlined`}
      style={combinedStyle}
      {...props}
    >
      {children}
    </span>
  );
};
